import clsx from 'clsx';
import { Link } from 'react-router-dom';
import type { OrderInfo } from '../../stores/klanten-store';
import { BRAND_COLORS, ORDER_STATUS_COLORS } from '../../lib/order-constants';
import { formatCurrency, formatDate } from '../../lib/format';

interface Props {
  werkaanvragen: OrderInfo[];
}

export function WerkaanvragenTab({ werkaanvragen }: Props) {
  if (werkaanvragen.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-32 text-slate-400">
        <p className="text-sm">Geen werkaanvragen gevonden</p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-slate-100">
      {werkaanvragen.map((wo) => (
        <Link
          key={wo.id}
          to={`/orders/${wo.id}`}
          className="block px-6 py-4 hover:bg-slate-50 transition-colors"
        >
          <div className="flex items-center justify-between mb-1">
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-slate-900">{wo.reference}</span>
              <span className={clsx(
                'text-[10px] px-1.5 py-0.5 rounded font-medium',
                ORDER_STATUS_COLORS[wo.status] || 'bg-slate-100 text-slate-600'
              )}>
                {wo.status}
              </span>
              {wo.brand && (
                <span className={clsx(
                  'text-[10px] px-1.5 py-0.5 rounded font-medium',
                  BRAND_COLORS[wo.brand] || 'bg-slate-100 text-slate-600'
                )}>
                  {wo.brand === 'SCHOONHUISSHOP' ? 'SHS' : wo.brand}
                </span>
              )}
            </div>
            {wo.total > 0 && (
              <span className="text-sm font-medium text-slate-900">{formatCurrency(wo.total)}</span>
            )}
          </div>
          <div className="flex items-center gap-4 text-xs text-slate-500">
            <span>Aangemaakt {formatDate(wo.createdDate)}</span>
            {wo.pickupDate && <span>Ophalen: {formatDate(wo.pickupDate)}</span>}
            {wo.deliveryDate && <span>Bezorgen: {formatDate(wo.deliveryDate)}</span>}
          </div>
        </Link>
      ))}
    </div>
  );
}
